var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRightArrowInWhite = function SvgRightArrowInWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.428,
    cy: 27.391,
    rx: 27.428,
    ry: 27.391,
    transform: "rotate(-.14 54.855 .063)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.867 36.547 9.116-9.156-9.168-9.105",
    stroke: "#023E11",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
export { SvgRightArrowInWhite as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTUiIGhlaWdodD0iNTUiIHZpZXdCb3g9IjAgMCA3MCA3MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGVsbGlwc2UgY3g9IjI3LjQyOCIgY3k9IjI3LjM5MSIgcng9IjI3LjQyOCIgcnk9IjI3LjM5MSIgdHJhbnNmb3JtPSJtYXRyaXgoMC45OTk5OTcgLTAuMDAyNjI1OSAwLjAwMjYzMyAwLjk5OTk5NyAwIDAuMTQ0MDQzKSIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTIzLjg2NjcgMzYuNTQ2OUwzMi45ODM1IDI3LjM5MDhMMjMuODE1IDE4LjI4NjMiIHN0cm9rZT0iIzAyM0UxMSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K";